<template>
  <img
    v-if="pixel"
    v-show="false"
    :src="`https://biscotti.yektanet.com/pixel?id=atiyacrowd&window_id=${$cookies.get(
      'window_id'
    )}`"
  />

  <Loading v-if="loading"></Loading>
  <div
    class="protected float fix flex wrap center vcenter"
    :class="{ show: protect }"
  >
    <div class="content flex wrap center vcenter">
      <img v-lazy="'/images/icon.webp'" alt="آتیاکراد" loading="lazy" />
      <p>محتوای محافظت شده...</p>
    </div>
    <div class="overlay blur"></div>
  </div>
  <RouterView v-if="!maintenance" />
  <notifications position="top left" :duration="6000" :pauseOnHover="true" />
</template>

<script>
/* eslint-disable */
import RouterView from "vue-router";
import Loading from "./components/Loading.vue";

export default {
  name: "App",
  inject: ["base"],
  components: {
    Loading,
    RouterView,
  },
  mounted() {
    if (this.inspect) {
      document.addEventListener("contextmenu", (e) => e.preventDefault());
      document.onkeydown = (e) => {
        if (e.key === 123) e.preventDefault();
        if (e.ctrlKey && e.shiftKey && e.key === "I") e.preventDefault();
        if (e.ctrlKey && e.shiftKey && e.key === "C") e.preventDefault();
        if (e.ctrlKey && e.shiftKey && e.key === "J") e.preventDefault();
        if (e.ctrlKey && e.key === "U") e.preventDefault();
      };
    }
  },
  created() {
    this.base.API().post(
      `Analysis/Session/Collect`,
      {
        data: {
          window_id: this.$cookies.get("window_id") || null,
        },
      },
      (response) => {
        if (this.base.Util().success(response) && response.data.data)
          this.$cookies.set(
            "window_id",
            response.data.data,
            "1Y",
            "/",
            ".atiyehiraniancf.com"
          );
        this.pixel = true;
      },
      (error) => {}
    );
  },
  data() {
    return {
      inspect: false,
      loading: false,
      protect: false,
      maintenance: false,
      pixel: false,
    };
  },
  watch: {
    $route: {
      handler(to) {
        const baseUrl = "https://atiyehiraniancf.com";
        const canonicalUrl = baseUrl + to.fullPath;

        let link = document.querySelector("link[rel='canonical']");
        if (link) {
          link.setAttribute("href", canonicalUrl);
        } else {
          link = document.createElement("link");
          link.setAttribute("rel", "canonical");
          link.setAttribute("href", canonicalUrl);
          document.head.appendChild(link);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style src="../src/assets/css/main.css" />
<style lang="less" src="../src/assets/css/main.less" />
<style src="vue3-carousel-3d/dist/index.css"></style>
<style src="../src/assets/css/views/shared.css" />
